import React from 'react';
import PropTypes from 'prop-types';
import DateFilter from '../common/dateFilter';

const validateDate = (filter, date) => {
  let dateValue;
  if (filter) {
    dateValue = filter;
  } else if (date) {
    dateValue = date.substring(0, 10);
  } else {
    dateValue = new Date();
  }
  return dateValue;
};

const Header = props => (
  <div className="header">
    <div className="box-form islabel box170">
      <div>
        <label htmlFor="group">{props.language.filter.group}</label>
      </div>
      <div>
        <select
          value={props.select.toLowerCase()}
          id="group"
          data-type="select"
          onChange={props.handleSubmit}
        >
          {props.group.map((item, i) => (
            <option value={item} key={`group-${i}`}>
              {props.language.filter[item.toLowerCase()]}
            </option>
          ))}
        </select>
      </div>
    </div>
    <div className="box-form islabel box170">
      <div>
        <label htmlFor="date-start">{props.language.filter.from}</label>
      </div>
      <div>
        <DateFilter
          date={validateDate(props.filters.date.fechaStartFinal, props.date.response.maxDate)}
          dif={props.filters.date.fechaStartFinal ? 0 : -1123200000}
          id="date-start"
          handleSubmit={props.handleSubmit}
        />
      </div>
    </div>
    <div className="box-form islabel box170">
      <div>
        <label htmlFor="date-end">{props.language.filter.to}</label>
      </div>
      <div>
        <DateFilter
          date={validateDate(props.filters.date.fechaEndFinal, props.date.response.maxDate)}
          dif={0}
          id="date-end"
          handleSubmit={props.handleSubmit}
        />
      </div>
    </div>
  </div>
);

Header.propTypes = {
  select: PropTypes.string.isRequired,
  group: PropTypes.oneOfType([PropTypes.array]).isRequired,
  filter: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]).isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired,
  date: PropTypes.oneOfType([PropTypes.object]).isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/summary_nfa/header.jsx